import React, { useState, useEffect, useRef } from "react";
import validator from "validator";
import axios from "axios";
import { useAuth } from "../contexts/auth";
import { postCustomersURL } from "../utils/api";
import { useReactToPrint } from 'react-to-print';
import {
    Flex,
    Spacer,
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    FormControl,
    FormLabel,
    FormErrorMessage,
    FormHelperText,
    Input,
    Text,
    RadioGroup,
    Radio,
    HStack,
    Box,
    InputRightElement,
    Image,
    Table,
    Thead,
    Tfoot,
    Tbody,
    Th,
    Tr,
    Td,
    VStack,
} from "@chakra-ui/react";
import EasyChekLogo from "assets/images/easychek_logo.jpg";

function ViewPayment({
    isOpen,
    onClose,
    orderData,
    paymentId,
}) {


    if (orderData == null && paymentId == null) {
        return (<></>);
    }

    const [ paymentData, setPaymentData ] = useState(null);


    // console.log(partsTotal, laborTotal);

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    useEffect(() => {
        // console.log(orderData, paymentId);
        if (orderData && paymentId && isOpen) {
            if (orderData.payments.length > 0) {
                orderData.payments.forEach((p, osIndex) => {
                    // console.log(laborTotal);
                    if (p.id == paymentId) {
                        setPaymentData(p);
                    }
                });
            }
        }

    }, [orderData, isOpen, paymentId]);

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="full" isCentered >
            <ModalOverlay />
            <ModalHeader>
            </ModalHeader>
            <ModalContent>
                <ModalCloseButton />
                <ModalBody width={"100%"}  p={"32px"}>
                    <Flex direction={"row"}>
                        <Spacer />
                        <Box width={"50%"} 
                            // direction="column"
                            alignSelf="center"
                            justifySelf="center"
                        >
                            <VStack >
                                <Flex ref={componentRef}
                                    direction="column"
                                    alignSelf="center"
                                    justifySelf="center"
                                    justifyContent="center"
                                    width={"99%"} 
                                    m="4px"
                                    mt="10px"
                                >
                                <style type="text/css" media="print">{"\
                                    @page {\ size: A4;\ }\
                                "}</style>
                                    
                                    {/** Logo and Header */}
                                    <Flex 
                                        direction="row"
                                        textAlign="center"
                                        justifyContent="center"
                                        align="center"
                                        mt="4px"
                                        mb="12px"
                                    >
                                        <Image
                                            // boxSize="100px"
                                            width={"120px"}
                                            objectFit="fit"
                                            src={EasyChekLogo}
                                            alt="Easy Chek 7 Logo"
                                        />
                                        <Flex direction={"column"}>
                                            <Text 
                                                fontSize="22px"
                                                color={"black"}
                                                fontWeight="bold"
                                                textAlign="center"
                                            >
                                                EASY CHEK 7 AUTO SERVICE CORP.
                                            </Text>
                                            <Text
                                                fontSize="xs"
                                                textAlign="center"
                                            >
                                                14-5 FIL AM ROAD CUTCUT ANGELES CITY PAMPANGA
                                            </Text>
                                            <Text
                                                fontSize="xs"
                                                textAlign="center"
                                            >
                                                CONTACT NO. 0917631-8628(GLOBE) AND 0943-706-0855(SMART)
                                            </Text>
                                        </Flex>
                                    </Flex>

                                    {/** TABLE */}
                                    <Table width={"100%"} border={"1px solid gray"} variant="unstyled">
                                        <Thead>
                                            <Tr p={0}>
                                                <Th colSpan={12}
                                                    borderBottom={"1px solid gray"}>
                                                    <Text 
                                                        fontSize="20px"
                                                        color={"black"}
                                                        fontWeight="bold"
                                                        textAlign="center"
                                                    >
                                                        JOB ORDER PAYMENT
                                                    </Text>
                                                </Th>
                                            </Tr>
                                        </Thead>
                                        <Tbody>
                                            <Tr>
                                                <Td fontSize="xs"
                                                    textAlign="start"
                                                    paddingInlineStart={2} 
                                                    paddingTop={0}
                                                    paddingBottom={0}
                                                >NAME: {orderData.customer.firstName} {orderData.customer.lastName}</Td>
                                                <Td colSpan={8}
                                                ></Td>
                                                <Td fontSize="xs"
                                                    textAlign="start"
                                                    borderLeft={"1px solid gray"}
                                                    paddingInlineStart={2}
                                                    paddingTop={0}
                                                    paddingBottom={0}
                                                    colSpan={3}
                                                >DATE: </Td>
                                            </Tr>
                                            <Tr border={"1px"}>
                                                <Td fontSize="xs"
                                                    textAlign="start"
                                                    paddingInlineStart={2}
                                                    paddingTop={0}
                                                    paddingBottom={0}
                                                >CONTACT NO: {orderData.customer.mobile ?? ""}</Td>
                                                <Td colSpan={8}></Td>
                                                <Td colSpan={3}
                                                    fontSize="xs"
                                                    textAlign="center"
                                                    borderLeft={"1px solid gray"}
                                                    paddingTop={0}
                                                    paddingBottom={0}
                                                >WORKING DAYS</Td>
                                            </Tr>
                                            <Tr border={"1px"}>
                                                <Td fontSize="xs"
                                                    textAlign="start"
                                                    paddingInlineStart={2}
                                                    paddingTop={0}
                                                    paddingBottom={0}
                                                >ADDRESS:</Td>
                                                <Td colSpan={8}></Td>
                                                <Td colSpan={3}
                                                    fontSize="xs"
                                                    textAlign="center"
                                                    borderLeft={"1px solid gray"}
                                                    paddingTop={0}
                                                    paddingBottom={0}
                                                >{ orderData.workingDays ?? ""}</Td>
                                            </Tr>
                                            <Tr border={"1px"}>
                                                <Td fontSize="xs"
                                                    textAlign="start"
                                                    colSpan={3}
                                                    borderRight={"1px solid gray"}
                                                    paddingInlineStart={2}
                                                    paddingTop={1}
                                                    paddingBottom={0}
                                                >MAKE: {orderData.carMake ?? ''}</Td>
                                                <Td fontSize="xs"
                                                    textAlign="start"
                                                    colSpan={3}
                                                    borderRight={"1px solid gray"}
                                                    paddingInlineStart={2}
                                                    paddingTop={1}
                                                    paddingBottom={0}
                                                >TYPE: {orderData.carType ?? ''}</Td>
                                                <Td fontSize="xs"
                                                    textAlign="start"
                                                    colSpan={2}
                                                    borderRight={"1px solid gray"}
                                                    paddingInlineStart={2}
                                                    paddingTop={1}
                                                    paddingBottom={0}
                                                >YEAR: {orderData.carYear ?? ''}</Td>
                                                <Td fontSize="xs"
                                                    textAlign="start"
                                                    colSpan={2}
                                                    borderRight={"1px solid gray"}
                                                    paddingInlineStart={2}
                                                    paddingTop={1}
                                                    paddingBottom={0}
                                                >PLATE NO: {orderData.carPlate ?? ''}</Td>
                                                <Td fontSize="xs"
                                                    textAlign="start"
                                                    colSpan={2}
                                                    paddingInlineStart={2}
                                                    paddingTop={1}
                                                    paddingBottom={0}
                                                >ODOMETER:  {orderData.carOdometer ?? ''}</Td>
                                            </Tr>

                                            <Tr border={"1px"}>
                                                <Td fontSize="md"
                                                    textAlign="center"
                                                    colSpan={4}
                                                    borderRight={"1px solid gray"}
                                                    paddingTop={2}
                                                    paddingBottom={1}
                                                >TYPE</Td>
                                                <Td fontSize="md"
                                                    textAlign="center"
                                                    colSpan={4}
                                                    borderRight={"1px solid gray"}
                                                    paddingTop={2}
                                                    paddingBottom={1}
                                                >AMOUNT</Td>
                                                <Td fontSize="md"
                                                    textAlign="center"
                                                    colSpan={4}
                                                    borderRight={"1px solid gray"}
                                                    paddingTop={2}
                                                    paddingBottom={1}
                                                >DATE</Td>
                                            </Tr>

                                            { paymentData 
                                                ? <Tr border={"1px"}>
                                                        <Td fontSize="md"
                                                            textAlign="center"
                                                            colSpan={4}
                                                            borderRight={"1px solid gray"}
                                                            paddingTop={2}
                                                            paddingBottom={1}
                                                        >{paymentData.type}
                                                        {paymentData.type && paymentData.type == 'Online'
                                                            ? <>
                                                                <br/>
                                                                Bank: {paymentData.bank}<br/>
                                                                Ref No: {paymentData.referenceNumber}
                                                            </>
                                                            : null
                                                        }
                                                        {paymentData.type && paymentData.type == 'Cheque'
                                                            ? <>
                                                                <br/>
                                                                Account No: {paymentData.accountNumber}<br/>
                                                                Account Name: {paymentData.accountName}<br/>
                                                                Cheque Name: {paymentData.chequeNumber}
                                                            </>
                                                            : null
                                                        }
                                                        </Td>
                                                        <Td fontSize="md"
                                                            textAlign="center"
                                                            colSpan={4}
                                                            borderRight={"1px solid gray"}
                                                            paddingTop={2}
                                                            paddingBottom={1}
                                                        >₱{paymentData.amount}</Td>
                                                        <Td fontSize="md"
                                                            textAlign="center"
                                                            colSpan={4}
                                                            borderRight={"1px solid gray"}
                                                            paddingTop={2}
                                                            paddingBottom={1}
                                                        >{new Date(Date.parse(paymentData.dateTime)).toLocaleString()}</Td>
                                                    </Tr>
                                                : null
                                            }

                                            <Tr border={"1px"}>
                                                <Td fontSize="xs"
                                                    textAlign="start"
                                                    colSpan={4}
                                                    paddingTop={0}
                                                    paddingBottom={0}
                                                    paddingInlineStart={2}
                                                >CUSTOMER SIGNATURE</Td>
                                                <Td
                                                    colSpan={8}
                                                    borderRight={"1px solid gray"}
                                                ></Td>
                                            </Tr>

                                            <Tr border={"1px"}>
                                                <Td fontSize="xs"
                                                    fontWeight="bold"
                                                    textAlign="center"
                                                    colSpan={3}
                                                    borderRight={"1px solid gray"}
                                                    paddingTop={0}
                                                    paddingBottom={0}
                                                >ORDER TOTAL</Td>
                                                <Td
                                                    colSpan={9}
                                                    borderRight={"1px solid gray"}
                                                    paddingTop={0}
                                                    paddingBottom={0}
                                                >
                                                    <Text fontWeight={"bold"}>₱{orderData.total}</Text>
                                                </Td>
                                            </Tr>

                                        </Tbody>
                                        {/* <Tfoot>
                                            <Tr>
                                            <Th>To convert</Th>
                                            <Th>into</Th>
                                            <Th isNumeric>multiply by</Th>
                                            </Tr>
                                        </Tfoot> */}
                                    </Table>
                                </Flex>
                                <Button 
                                    colorScheme="teal" 
                                    variant="solid"
                                    onClick={() => handlePrint()}
                                >
                                    <Text
                                        fontSize="sm"
                                        fontWeight="600"
                                        color="teal.300"
                                        alignSelf="center"
                                    >
                                        PRINT THIS
                                    </Text>
                                </Button>
                            </VStack>
                        </Box>
                        <Spacer />
                    </Flex>
                </ModalBody>
            </ModalContent>
        </Modal>
    );

}



export default ViewPayment;
